const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://69znshin72.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://fqq2ved5x4.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://bj4n1p16l1.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.1',
    HOSTNAME: 'https://locations.staging.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://ageuaq1co8.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;